const WEB_PROTOCOLS = ['https:', 'http:'];

const parseUrl = target => {
  if (typeof target !== 'string' || !target) return null;

  try {
    return new URL(target, window.location.href);
  } catch {
    return null;
  }
};

export const sameOriginUrl = target => {
  const url = parseUrl(target);
  if (!url || !WEB_PROTOCOLS.includes(url.protocol) || url.origin !== window.location.origin) {
    return null;
  }

  return url.href;
};

export const externalUrlOnDomain = (target, domain) => {
  const url = parseUrl(target);
  if (!url || url.protocol !== 'https:') return null;

  const hostname = url.hostname.toLowerCase();
  if (hostname !== domain && !hostname.endsWith(`.${domain}`)) return null;

  return url.href;
};
